import React from 'react';
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import {PolIcon} from "components/PolIcon/policon";
import PolToast from "v4/components/ui/PolToast/PolToast";
import PolToaster from "v4/components/ui/PolToaster/PolToaster";
import useProcessImport
    from "v4/pages/admin/Import/components/ImportSteps/components/ProcessImport/hooks/useProcessImport";

export default function ProcessImport() {
    const {t} = usePolTranslation();
    useProcessImport();

    return (
        <PolToaster portalRootSelector=".admin__wrapper">
            <PolToast>
                <div className="process-import__progress_wrapper">
                    <p className="process-import__progress_text">
                        <PolIcon icon="circle-notch" className="spinner"/>
                        {t('import_data_in_progress')}
                    </p>
                </div>
            </PolToast>
        </PolToaster>
    )
}
